/**
 * Whether Meta's setup was postponed to look around in simulation mode.
 *
 * It lasts as long as the tab: reopening the panel another day greets with the setup again,
 * which is what an installation that still cannot send anything should do.
 */

const KEY = "instagain:setup-dismissed";

export function isSetupDismissed(): boolean {
  try {
    return sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissSetup(): void {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch {
    // Without storage the setup simply comes back on the next reload.
  }
}
